import { render } from "./ElementsPool.vue?vue&type=template&id=5378596f"
import script from "./ElementsPool.vue?vue&type=script&lang=js"
export * from "./ElementsPool.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__